import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AppStorage } from './appStorage.service';
import { ENDPOINTS } from '../constants/app-values';

@Injectable({
  providedIn: 'root'
})
export class ApiLogoService {
  constructor(private httpClient: HttpClient, private appStorage: AppStorage) {}

  getLogo() {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    return this.httpClient
      .get(`${ENDPOINTS.HOST}/logo/`, { headers: headers })
      .toPromise();
  }

  guardarLogo(logo) {
    const headers = new HttpHeaders({
      'Content-type': 'application/json',
      Authorization: this.appStorage.token
    });

    const body = {
      logo: logo
    };

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/logo/`, body, {
        headers: headers
      })
      .toPromise();
  }

  subirLogo(file: File) {
    const headers = new HttpHeaders({
      Authorization: this.appStorage.token
    });

    const formData = new FormData();
    formData.append('file', file);
    formData.append('name', 'logo/logo.png');
    /* while ceating bucket we alread grant the public access
      for read operation as if now we are only performing that.*/

    return this.httpClient
      .post(`${ENDPOINTS.HOST}/awsFile/logo/subir/`, formData, {
        headers: headers
      })
      .toPromise();
  }
}
